module.exports = __webpack_public_path__ + "0ee8a1afd6f49a71321cd5f5afe4121b.jpg";